var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ionic-container rounded",attrs:{"align":"center","id":"parent_container"}},[_c('div',{staticStyle:{"height":"100%"},attrs:{"id":_vm.constructionSite}})])
}
var staticRenderFns = []

export { render, staticRenderFns }